import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_catalog_picker_component = _resolveComponent("catalog-picker-component")!

  return (_openBlock(), _createBlock(_component_catalog_picker_component, {
    ref: "c",
    disabled: _ctx.disabled,
    auth: "",
    modelValue: _ctx.selectedCounterparty,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCounterparty) = $event)),
      _ctx.onSelectChange
    ],
    placeholder: "Поиск контрагентов по инициалам, телефону",
    "search-url": "/api/counterparties/search"
  }, {
    label: _withCtx(() => [
      _createTextVNode(_toDisplayString(`${_ctx.selectedCounterparty?.lastname} ${_ctx.selectedCounterparty?.firstname} ${_ctx.selectedCounterparty?.middlename ?? ''}`), 1)
    ]),
    default: _withCtx((scope) => [
      _createTextVNode(_toDisplayString(`${scope.lastname} ${scope.firstname} ${scope.middlename}`), 1)
    ]),
    _: 1
  }, 8, ["disabled", "modelValue", "onUpdate:modelValue"]))
}